import svg4everybody from 'svg4everybody';

export default () => {
    svg4everybody();

    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('safari') != -1 && userAgent.indexOf('chrome') == -1) {
        document.querySelector('body').classList.add('-position-fixed');
    }
}
